import { Card, Typography } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import React from "react";

import { statusIcons } from "../../constants";
import useStyles from "./StatusCard.styles";

export default function StatusCard({ card, onClick }) {
	const classes = useStyles();
	const iconConfig = statusIcons[card.status];
	const Icon = iconConfig.icon;

	return (
		<Card
			className={`${classes.smallStatusCard} ${classes.clickableCard}`}
			onClick={onClick}
		>
			<div className={classes.statusHeader}>
				<Typography className={classes.statusTitle}>{card.title}</Typography>
				<ChevronRightIcon className={classes.rowArrow} />
			</div>
			<div className={classes.statusValueLine}>
				<Icon
					className={classes.statusIcon}
					style={{ color: iconConfig.color }}
				/>
				<Typography className={classes.statusValue}>{card.value}</Typography>
			</div>
		</Card>
	);
}
